import { render, staticRenderFns } from "./CallsinQueue.vue?vue&type=template&id=370cca5e&scoped=true"
import script from "./CallsinQueue.vue?vue&type=script&lang=js"
export * from "./CallsinQueue.vue?vue&type=script&lang=js"
import style0 from "./CallsinQueue.vue?vue&type=style&index=0&id=370cca5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370cca5e",
  null
  
)

export default component.exports